import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../../services/axios-client"
import { useNavigate } from "react-router-dom"

const usePhaseForm = () => {
    const navigate = useNavigate()
    const [isSaving, setIsSaving] = useState(false)
    const [payload, setPayload] = useState({
        ID: '',
        Name: '',
        Order: ''
    })

    const onChangeHandler = (e) => {
        setPayload({ ...payload, [e.target.name]: e.target.value })
    }

    const postPhaseForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/phases', {
                Name: payload.Name,
                Order: parseInt(payload.Order)
            })
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Create Phase")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const putPhaseForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/phases', {
                ID: payload.ID,
                Name: payload.Name,
                Order: parseInt(payload.Order)
            })
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Update Phase")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const getPhaseForm = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/phases/${id}`)
            if (res.status === 200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        onChangeHandler,
        postPhaseForm,
        putPhaseForm,
        isSaving,
        getPhaseForm
    }
}

export default usePhaseForm